module.exports = __webpack_public_path__ + "img/3.3e57de0a.png";